import Header from '../../components/MarginalsV2/Header';
import Products from '../../components/main/Products';
import Footer from '../../components/MarginalsV2/Footer';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';

export default function ProductsPage() {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = t("product")
  }, []);

  return (
    <>
      <Header renderBg={true} className="py-2" />

      <Products />
      <Footer />
    </>
  );
}
